import { FC } from 'react';

import { DLMROI } from '../../../core/doclabel';

import {    
  PendingInspectionForm,
  SubmitNoteResponseForm,
  SubmitSignedROIForm
} from './forms'

type Props = {
  siteID: number
  siteState: string
  projectName: string
  projectLocation: string
  appID: number
  siteROIS: Array<DLMROI>
  doClose: Function    
}

const SubmitInspectionResponseForm: FC<Props> = ({siteID, siteState, projectName, projectLocation, siteROIS, appID, doClose}) => {
  
  return(
  <div id='kt_dlm_submit_inspection_response_form' className='form'>
    <div
      className='d-flex flex-column p-4'
    >    
      { siteState === 'Pending Site Labelling' &&
      <PendingInspectionForm id={siteID} appID={appID} projectName={projectName} projectLocation={projectLocation}  doClose={doClose} />
      }
                  
      { siteState === 'Applicant Sign' && 
      <SubmitSignedROIForm id={siteID} appID={appID} rois={siteROIS} doClose={doClose} />
      }

      { ['Site Labelling - Issue','Applicant Confirmation','Pending Re-Site Labelling'].includes(siteState)  &&
      <SubmitNoteResponseForm id={siteID} state={siteState} appID={appID} doClose={doClose} hasVerdict={['Applicant Confirmation'].includes(siteState)}/>            
      }
      
    </div>
  </div>    
  )      
}

export {SubmitInspectionResponseForm}
